// src/Components/IncomesTable.jsx
import { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableRow,
  Typography, CircularProgress, Box,
  Tooltip, TextField, Stack, Button, InputAdornment, Dialog,
  DialogTitle, DialogContent, DialogActions,IconButton
} from "@mui/material";
import { DataGrid} from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../../../Components/FuncionesGenerales/DataGrid";
import { CalendarToday } from "@mui/icons-material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import "../../../Css/Paginas.css"
import { useIncomesService } from "../../../Services/Incomes";
import { FaTrashCan } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";
import { buttonGuardar, inputFecha,  buttonCerrar, buttonCancelar } from "../../../Layouts/CustomStyles";
import { EditarIncome } from "./EditarIngresos";
import Logocolor from "../../../Image/Logo.png";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
const getCurrentMonth = () => {
  const fecha = new Date();
  return fecha.toLocaleString("es-CL", { month: "long" });
};


function IncomesTable({ refresh }) {
  const { getIncomes, DeleteIncomes } = useIncomesService();
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [incomeToEdit, setIncomeToEdit] = useState(null);
  /* estados */
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedIncome, setSelectedIncome] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
 const [expandedRowId, setExpandedRowId] = useState(null);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      setError("");

      const params = {};
      if (from) params.from = from;
      if (to) params.to = to;

      const data = await getIncomes(params);
      setIncomes(data);
    } catch (err) {
      setError(err.message || "Error al cargar ingresos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to, refresh]);

  const handleOpenDialog = (income) => {
    setSelectedIncome(income);
    setOpenDialog(true);
    setDeleteSuccess(false);
  };

  const handleCloseDialog = () => {
    if (!deleting) {
      setOpenDialog(false);
      setSelectedIncome(null);
    }
  };
  const handleOpenEditDialog = (income) => {
    setIncomeToEdit(income);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setIncomeToEdit(null);
  };

  const handleConfirmDelete = async () => {
    if (!selectedIncome) return;
    setDeleting(true);
    try {
      await DeleteIncomes(selectedIncome.id);
      await fetchData();
      setDeleteSuccess(true);
    } catch (error) {
      alert(error);
    } finally {
      setDeleting(false);
    }
  };



  const formatCLP = (amount) => {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      minimumFractionDigits: 0,
    }).format(amount);
  };


const DetalleRow = ({ row }) => (
  <Box
    sx={{
      width: "100%",
      maxHeight: 200,
      overflowY: "auto",
      backgroundColor: "#f9fafb",
      p: 2,
      border: "1px solid #e0e0e0",
      borderRadius: 2,
      position:'absolute',
      zIndex:1
    }}
  >
    {row.details?.length > 0 && (
      <>
        <Typography sx={{ fontWeight: 600, mb: 1, fontFamily: "Poppins" }}>
          Distribución por Sucursal
        </Typography>

        {/* HEADER */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            fontWeight: 600,
            borderBottom: "2px solid #ddd",
            pb: 1
          }}
        >
          <span>Sucursal</span>
          <span>Monto</span>
          <span>Descripción</span>
        </Box>

        {/* FILAS */}
        {row.details.map((d) => (
          <Box
            key={d.id}
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              py: 1,
              borderBottom: "1px solid #eee",
              alignItems: "center",
            }}
          >
            <span>{d.branch?.name || d.branch_id}</span>
            <span>{formatCLP(d.amount)}</span>
            <span>{d.description || "-"}</span>
          </Box>
        ))}
      </>
    )}
  </Box>
);


  const columns = [
    {
  field: "expand",
  headerName: "",
  width: 60,
  sortable: false,
  renderCell: (params) => {
    if (params.row.isDetail) return null;

    const hasDetails =
      params.row.details && params.row.details.length > 0;

    if (!hasDetails) return null;

    return (
      <IconButton
        size="small"
        onClick={() =>
          setExpandedRowId(
            expandedRowId === params.row.id ? null : params.row.id
          )
        }
      >
        {expandedRowId === params.row.id ? (
          <RemoveIcon style={{ color: "#2a8d74" }} />
        ) : (
          <AddIcon style={{ color: "#2a8d74" }} />
        )}
      </IconButton>
    );
  },
},
    {
      field: "date",
      headerName: "Fecha",
      flex: 0.5,
       
  colSpan: (params) => {
    if (params?.row?.isDetail) return 13;
    return 1;
  },

  renderCell: (params) => {
    if (expandedRowId === params.row.id) {
      return <DetalleRow row={params.row} />;
    }
    return params.value;
  }
},
  
 
    {
      field: "total_amount",
      headerName: "Monto",
      flex: 0.5,
      renderCell: (params) => formatCLP(params.value),
      sortable: true,
    },
    
     {
      field: "income_type",
      headerName: "Ingreso",
      flex: 1,
      renderCell: (params) => params.row?.income_type?.name || "Desconocido"

    },
     {
      field: "estado",
      headerName: "Estado",
      width: 180,
      renderCell: (params) => {
        let color = "#ccc"; // default gris

        switch (params.value) {
          case
            "REGISTRADO":
            color = "#54ace7";
            break;
          case
            "PENDIENTE":
            color = "#f0ad4e";
            break;
          case
            "PAGADO":
            color = "#5cb85c";
            break;
          case
            "ANULADO":
            color = "#d98d4f";
            break;
          case "NO PAGO":
            color = "#d9534f";
            break;
          case
            "PROCESO":
            color = "#d7d94f";
            break;
          default:
            color = "#ccc";
        }

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* Cuadrado de color */}
            <Box
              sx={{
                width: 100,
                textAlign: 'center',

                color: '#fff',
                borderRadius: 1,
                backgroundColor: color,
              }}
            >
              <span style={{textTransform:'lowercase', fontFamily:'Poppins', fontWeight:'500'}}>{params.value}</span>
            </Box>
          </Box>
        );
      },
    },
   
    {
      field: "concept",
      headerName: "Descripción",
      flex: 1,
      renderCell: (params) => params.value || "-",
    },
    {
      field: "contact",
      headerName: "Contacto",
      flex: 1,
      renderCell: (params) => params.row?.contact?.name || "Desconocido"

    },
    {
      field: "branch",
      headerName: "Sucursal",
      flex: 1,
      renderCell: (params) => params.row?.branch?.name || "Desconocido"

    },
    {
      field: "user",
      headerName: "Administrador",
      flex: 1,
      renderCell: (params) => params.row?.user?.name || "Desconocido"

    },
    {
      field: "acciones",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: 150,
            alignItems: "center",
            justifyContent: "center",
          }}>

          <Tooltip title="Editar">
            <button className="edit-button" onClick={() => handleOpenEditDialog(params.row)}
            >
              <svg className="edit-svgIcon" viewBox="0 0 512 512">
                <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
              </svg>
            </button>
          </Tooltip>
          <Tooltip title="Eliminar">
            <button className="delete-button" onClick={() => handleOpenDialog(params.row)} >
              <FaTrashCan className="delete-svgIcon" />
            </button>
          </Tooltip>
        </Box>
      )
    }
  ];


  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px",
          gap: 2,
          position: "relative"
        }}
      >
        {/* Círculo */}
        <CircularProgress size={90} thickness={4} sx={{ color: '#6fd385ff' }} />

        {/* Imagen centrada encima del círculo */}
        <Box
          component="img"
          src={Logocolor}
          alt="Logo"
          sx={{
            width: "55px",
            height: "55px",
            position: "absolute",
            top: "90px"
          }}
        />

        <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
          Cargando...
        </Typography>
      </Box>
    );

  if (error)
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        p={4}
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
          backgroundColor: "#fafafa",
          textAlign: "center",
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 50, color: "#f57c00", mb: 2 }} />
        <Typography
          variant="h6"
          sx={{ fontFamily: "Poppins", color: "#585857" }}
        >
          Ups... no hay ingresos ingresados este mes de {getCurrentMonth()}
        </Typography>
      </Box>
    )



  return (
    <>
      {/* Filtros por fecha */}
      <Stack direction="row" spacing={2} mb={5} sx={{ mt: '-50px', display: 'flex', justifyContent: 'flex-end' }}>
        <TextField
          label="Desde"
          type="date"
          size="small"
          placeholder="AAAA-MM-DD"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={inputFecha}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CalendarToday />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Hasta"
          type="date"
          size="small"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={inputFecha}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CalendarToday />
              </InputAdornment>
            ),
          }}
        />
        <Button sx={buttonGuardar} onClick={fetchData}>
          Filtrar
        </Button>
      </Stack>

      <Box sx={{ width: "100%",  height: 600 }}>
        <DataGrid
          rows={incomes}
          columns={columns}
          getRowId={(row) => row.id}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 25]}
          getDetailPanelHeight={() => 600} 
            disableRowSelectionOnClick
            slots={{ noRowsOverlay: DiseñoDataGrid }}
            sx={{
              fontFamily: 'Poppins, sans-serif',
              '& .MuiDataGrid-columnHeaders': {
                color: '#113e21ff',
                fontWeight: 600,
                textTransform: 'capitalize',
              },
              '& .MuiDataGrid-cell': {
                textTransform: 'capitalize',
              },
            }}
        />
      </Box>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle sx={{ fontFamily: 'Poppins', color: '#585857' }}>
          {deleteSuccess ? "Ingreso eliminado" : "Confirmar eliminación"}
        </DialogTitle>

        <DialogContent dividers>
          {deleteSuccess ? (
            <>
              <div className="titleicondelete">
                <FaCheck className="svgdeletetitle" />
              </div>
              <Typography color="green" sx={{ fontFamily: 'Poppins', color: '#585857' }}>
                El ingreso ha sido eliminado correctamente.
              </Typography>
            </>
          ) : (
            <>
              <div className="titleicondelete">
                <FaTrashCan className="svgdeletetitle" />
              </div>
              <Typography sx={{ fontFamily: 'Poppins', color: '#585857' }}>
                ¿Seguro que deseas eliminar este ingreso?
              </Typography>

              {selectedIncome && (
                <Table size="small" sx={{ mt: 2 }}>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>Fecha</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>
                        {new Date(selectedIncome.date).toLocaleDateString("es-CL")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>Monto</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>{selectedIncome.total_amount}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>Tipo</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>{selectedIncome.income_type?.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>Contacto</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>{selectedIncome.contact?.name || ""}</TableCell>
                    </TableRow> <TableRow>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>Sucursal</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>{selectedIncome.branch?.name || ""}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>Usuario</TableCell>
                      <TableCell sx={{ fontFamily: 'Poppins', color: '#585857' }}>{selectedIncome.user?.name || ""}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          {!deleteSuccess ? (
            <>
              <Button onClick={handleCloseDialog} disabled={deleting} sx={buttonCancelar}>
                Cancelar
              </Button>
              <Button
                sx={buttonGuardar}

                onClick={handleConfirmDelete}
                disabled={deleting}
                startIcon={deleting && <CircularProgress size={18} />}
              >
                {deleting ? "Eliminando..." : "Confirmar"}
              </Button>
            </>
          ) : (
            <Button onClick={handleCloseDialog} sx={buttonCerrar}>Cerrar</Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog open={openEditDialog} onClose={handleCloseEditDialog} maxWidth="md" fullWidth>
        <DialogTitle>Editar Ingreso</DialogTitle>
        <DialogContent>
          {incomeToEdit && (
            <EditarIncome
              income={incomeToEdit}
              onClose={handleCloseEditDialog}
              onUpdated={fetchData} // refresca la tabla después de editar
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default IncomesTable;



